import { APIError } from '../../errors/APIError';
import { useAPIMutation } from '../../useAPIProvider';

interface CreateAdditionalStockArgs {
  catalogItemId: string;
  minimumStockLevel: number;
  maximumStockLevel: number;
  stockLevelId: string;
}

export const useUpsertAdditionalBundleStock = (mspId: string, customerId: string) => {
  return useAPIMutation(client => {
    return async (stock: CreateAdditionalStockArgs[]) => {
      const stockLevelId = stock && stock[0].stockLevelId;

      const response = await client.additionalStock.upsertAdditionalBundleStock({
        body: stock,
        params: {
          mspId,
          customerId,
          stockLevelId
        }
      });

      if (response.status !== 200) throw APIError.fromResponse(response);

      return response.body;
    };
  });
};

export const useUpsertAdditionalGeneralStock = (mspId: string, customerId: string) => {
  return useAPIMutation(client => {
    return async (stock: CreateAdditionalStockArgs[]) => {
      const stockLevelId = stock && stock[0].stockLevelId;

      const response = await client.additionalStock.upsertAdditionalGeneralStock({
        body: stock,
        params: {
          mspId,
          customerId,
          stockLevelId
        }
      });

      if (response.status !== 200) throw APIError.fromResponse(response);

      return response.body;
    };
  });
};
